import RevenueSplitCategory from '@/common/models/revenueSplit/RevenueSplitCategory';
import formatNumber from '@/utils/NumberFormatter';

export default class RevenueSplitCategoryGroup {
  name: string;
  categories: RevenueSplitCategory[];

  constructor(name, categories) {
    this.name = name;
    this.categories = categories;
  }

  get revenue() {
    return this.categories.reduce((mem, x) => mem + x.revenue, 0);
  }

  get revenuePercent() {
    return this.categories.reduce((mem, x) => mem + x.revenuePercent, 0);
  }

  get revenueFormatted() {
    return `${Math.round(this.revenue)}`.length % 3 === 0
      ? formatNumber(this.revenue, '$0a')
      : formatNumber(this.revenue, '$0.0a');
  }
}
